import { useIntl } from "react-intl";
import { Rome2rioLogo } from "src/svg/Rome2rioLogo";
import styled from "styled-components";
import { font_size, font_weight } from "src/design-system/tokens/typography";
import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import { Button } from "src/design-system/components/Button/Button";
import ChevronLeft from "src/design-system/icons/ChevronLeft.svg?react";
import color from "src/design-system/tokens/color";
import { Icon } from "../Icon/Icon";
import messages from "./Navbar.messages";

type NavbarProps = {
  headingText?: string;
  onBackClick?: () => void;
};

export function Navbar({ headingText, onBackClick }: NavbarProps) {
  const intl = useIntl();

  return (
    <HeaderContainer>
      <Header>
        {onBackClick && (
          <Button
            className="absolute top-1/2 left-2 -translate-y-1/2 py-1"
            variant="subtle"
            size="small"
            onPress={handleClick(onBackClick)}
          >
            <ChevronLeft />
            <span className="sr-only">
              {intl.formatMessage(messages.backLabel)}
            </span>
          </Button>
        )}
        <HeadingText>{headingText}</HeadingText>
      </Header>
    </HeaderContainer>
  );
}

export function ErrorNavbar() {
  return (
    <HeaderContainer>
      <Header>
        <SiteLogo />
      </Header>
    </HeaderContainer>
  );
}

function SiteLogo() {
  const intl = useIntl();

  return (
    <HeadingWrapper>
      <a href="/">
        <span className="sr-only">
          {intl.formatMessage(messages.logoLabel)}
        </span>
        <StyledIcon size="md">
          <Rome2rioLogo title="logo" tint="cod" />
        </StyledIcon>
      </a>
    </HeadingWrapper>
  );
}

function handleClick(callback: () => void) {
  return () => {
    sendAnalyticsInteractionEvent({
      category: "TopNav",
      action: "Click:BackButton",
    });
    callback();
  };
}

const headerHeight = "44px";

const HeaderContainer = styled.div`
  display: inline;
`;

const Header = styled.header`
  height: ${headerHeight};
  text-align: center;
  line-height: ${headerHeight};
  position: sticky;
  left: 0;
  top: 0;
  right: 0;
  z-index: 50;
  background-color: ${color.bg.surface.secondary};
  color: ${color.text.primary};
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.05);
`;

const HeadingWrapper = styled.h1`
  display: inline-block;
`;

const HeadingText = styled.h1`
  font-size: ${font_size.text_sm};
  font-weight: ${font_weight.normal};
  padding: 0 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: ${headerHeight};
`;

const StyledIcon = styled(Icon)`
  width: 85px;
  height: 42px;
`;
